import styled from 'styled-components'
import { theme } from '../../styles/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Label = styled.label`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: #222222;
`

export const Input = styled.input`
  height: 40px;
  padding: 5px;
  background: #FFFFFF;
  border: 0.3px solid #C4C4C4;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  border-radius: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #A0A0A0;

  &:disabled {
    background: ${theme.colors.secondGray};
  }
`
